import { useMemo } from 'react';
import { hasCommentingFeature } from '../utils/features';
import useCollaborationSidebarState from './useCollaborationSidebarState';
export default function useHasCommentingFeature() {
  const {
    enabledFeatures
  } = useCollaborationSidebarState();
  return useMemo(() => hasCommentingFeature(enabledFeatures), [enabledFeatures]);
}